import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white text-center py-3 mt-auto">
      © {currentYear} Birla Paints CDP. All rights reserved.
    </footer>
  );
}

export default Footer;
